var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'router-home': _vm.$route.fullPath === '/',
    'router-engineering': _vm.$route.fullPath === '/engineering',
    'router-about': _vm.$route.fullPath === '/about',
    'router-design': _vm.$route.fullPath === '/design',
    'router-changelog': _vm.$route.fullPath === '/changelog'
  },attrs:{"id":"app"}},[_c('Navbar'),_c('main',{attrs:{"role":"main"}},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1),_c('Footer'),_c('CookieLaw'),_c('UpdatePwa')],1)}
var staticRenderFns = []

export { render, staticRenderFns }